import { FC, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAnglesLeft,
  faAngleLeft,
  faAnglesRight,
  faAngleRight,
} from '@fortawesome/free-solid-svg-icons';
import styles from './styles.module.css';
import classNames from 'classnames';

type Props = {
  page: number;
  perPage: number;
  total: number;
  onPage: (page: number) => void;
};

const Pagenation: FC<Props> = ({ page, perPage, total, onPage }) => {
  const pageMax = Math.max(1, Math.ceil(total / perPage));
  const pageMin = 1;
  useEffect(() => {
    onPage(pageMin);
  }, [perPage]);
  const goLast = () => onPage(pageMax);
  const goFirst = () => onPage(pageMin);
  const goNext = () => onPage(page + 1);
  const goBefore = () => onPage(page - 1);

  const firstItemCountInPage = (page - 1) * perPage + 1;
  const lastItemCountInPage = Math.min(page * perPage, total);
  const itemsNote = total
    ? `全 ${total} 件中 ${firstItemCountInPage} 件 ~ ${lastItemCountInPage} 件を表示`
    : `全 0 件中 0 件を表示`;
  if (pageMax === pageMin) {
    return (
      <div className={styles.container}>
        <div className={styles.itemNote}>{itemsNote}</div>
        <div className={styles.buttons}>
          <div className={classNames(styles.button, styles.current)}>
            {page}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.itemNote}>{itemsNote}</div>
      <div className={styles.buttons}>
        {page !== pageMin && (
          <>
            <button
              onClick={goFirst}
              className={classNames(styles.button, styles.arrow)}
            >
              <FontAwesomeIcon icon={faAnglesLeft} />
            </button>
            <button
              onClick={goBefore}
              className={classNames(styles.button, styles.arrow)}
            >
              <FontAwesomeIcon icon={faAngleLeft} />
            </button>
            <button onClick={goBefore} className={styles.button}>
              {page - 1}
            </button>
          </>
        )}
        <div className={classNames(styles.button, styles.current)}>{page}</div>
        {page !== pageMax && (
          <>
            <button onClick={goNext} className={styles.button}>
              {page + 1}
            </button>
            <button
              onClick={goNext}
              className={classNames(styles.button, styles.arrow)}
            >
              <FontAwesomeIcon icon={faAngleRight} />
            </button>
            <button
              onClick={goLast}
              className={classNames(styles.button, styles.arrow)}
            >
              <FontAwesomeIcon icon={faAnglesRight} />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Pagenation;
